import React from 'react';
import { useAudioPlayer } from '../../state';
import TrackInfoLink from './TrackInfoLink';

export interface TrackTitleProps {}

const TrackTitle: React.FC<TrackTitleProps> = () => {
  const { title } = useAudioPlayer();

  return <TrackInfoLink data={title} variant="primary" />;
};

export default TrackTitle;
